import React, { FC } from 'react'
import { useScreenClass } from 'react-grid-system'
import styled from 'styled-components'

const Section = styled.section<{ isDesktop: boolean }>`
  background-color: #002244;
  padding: ${(props) => (props.isDesktop ? '4rem 2rem' : '2rem 1rem')};
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  gap: ${(props) => (props.isDesktop ? '3rem' : '1rem')};
  justify-items: ${(props) => (props.isDesktop ? 'center' : 'stretch')};
  /* 1 column on mobile, 2 on tablet, 3 on desktop */
  grid-template-columns: 1fr;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  border-radius: ${(props) => (props.isDesktop ? '16px' : '12px')};
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  @media (max-width: 480px) {
    max-width: 90%;
    margin: 0 auto;
  }
`

const Content = styled.div<{ isDesktop: boolean }>`
  color: #fff;
  max-width: ${(props) => (props.isDesktop ? '320px' : '100%')};
  margin: 0;
  text-align: center;       /* center text inside each block */
  padding: ${(props) => (props.isDesktop ? '1rem' : '0.75rem')};

  h3 {
    font-size: clamp(22px, 4.5vw, 30px);
    font-weight: 600;
    margin-bottom: 0.75rem;
    line-height: 1.2;
  }

  .content-large-text {
    font-size: clamp(26px, 7vw, 36px);
    font-weight: 700;
    margin: 0.75rem 0;
    line-height: 1.1;
  }

  p {
    font-size: clamp(14px, 3.5vw, 18px);
    margin: 0.5rem 0;
    line-height: 1.5;
  }
`

const Button = styled.button<{ variant: string; size: string }>`
  padding: ${(props) =>
    props.size === 'lg' ? '1.25rem 3.25rem' : '12px 2.5rem'};
  border: none;
  background-color: ${(props) =>
    props.variant === 'red'
      ? props.theme.colors.red
      : props.theme.colors.black};
  color: white;
  cursor: pointer;
  font-size: ${(props) => (props.size === 'lg' ? '22px' : '16px')};
  font-weight: 600;
  letter-spacing: 1.75px;
  transition: background-color 0.3s, transform 0.3s;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${(props) =>
      props.variant === 'red' ? '#B80000' : '#393939'};
    transform: scale(1.05);
  }

  @media (max-width: 480px) {
    width: 100%;
    padding: 0.9rem 1.5rem;
    font-size: 18px;
    letter-spacing: 1px;
  }
`

const ProgramDetails: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  return (
    <Section isDesktop={isDesktop}>
      <Content isDesktop={isDesktop}>
        <h3>Diverse</h3>
        <p className="content-large-text">Global Support</p>
        <p>Remote learning and in-person options available</p>
      </Content>
      <Content isDesktop={isDesktop}>
        <h3>Extensive</h3>
        <p className="content-large-text">2 Semesters / 8 Months</p>
        <p>September – May cohorts</p>
      </Content>
      <Content isDesktop={isDesktop}>
        <h3>Affordable</h3>
        <p className="content-large-text">$5,000 / semester</p>
        <p>Financial aid & payment plans available upon request</p>
      </Content>
      <div style={{ gridColumn: '1 / -1', textAlign: 'center', marginTop: '1.5rem' }}>
        <a href="https://stonybrookuniversity.co1.qualtrics.com/jfe/form/SV_3aqRXNG82X43wDI" target="_blank" rel="noopener noreferrer">
          <Button variant="red" size="lg">Start Application</Button>
        </a>
      </div>
    </Section>
  )
}

export default ProgramDetails
